import { useState } from "react";
import { useAction } from "convex/react";
import { Icon } from "./Icon";
import { api } from "../lib/api";
import { errorCode, setToken } from "../lib/session";

const MESSAGES: Record<string, string> = {
  WRONG_PASSPHRASE: "That passphrase isn't right.",
  TOO_MANY_ATTEMPTS: "Too many tries. Wait a minute and try again.",
  NOT_SET_UP: "This server has no passphrase yet. Run scripts/set-passphrase.mjs.",
};

export function SignIn() {
  const signIn = useAction(api.auth.signIn);
  const [pass, setPass] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!pass || busy) return;
    setBusy(true); setError(null);
    try {
      const { token } = await signIn({ passphrase: pass, device: `Web · ${navigator.userAgent.match(/(Firefox|Edg|Chrome|Safari)\/[\d.]+/)?.[0] ?? "browser"}` });
      setToken(token);
    } catch (err) {
      setError(MESSAGES[errorCode(err) ?? ""] ?? "Couldn't reach the server. Check your connection.");
    } finally { setBusy(false); }
  };
  return (
    <main className="signin">
      <form onSubmit={submit} className="signin-card">
        <span className="wm big"><Icon name="rss" size={26} /></span>
        <h1>VladRSS</h1>
        <p>Sign in with your passphrase.</p>
        <input className="inp" type="password" autoFocus autoComplete="current-password" value={pass} onChange={(e) => setPass(e.target.value)} aria-label="Passphrase" placeholder="Passphrase" />
        {error && <p className="err" role="alert">{error}</p>}
        <button className="btn primary lg" disabled={busy || !pass}>{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </main>
  );
}
